import { render, staticRenderFns } from "./PerformanceIndicators.vue?vue&type=template&id=2eb68108&scoped=true"
import script from "./PerformanceIndicators.vue?vue&type=script&lang=js"
export * from "./PerformanceIndicators.vue?vue&type=script&lang=js"
import style0 from "./PerformanceIndicators.vue?vue&type=style&index=0&id=2eb68108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb68108",
  null
  
)

export default component.exports